export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=0f7c8edd&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/index.vue?vue&type=template&id=0f7c8edd&scoped=true
// module id = /B0S
// module chunks = 0